export default function truncateWallet(address: string, lenght: number): string {
    return `${address.substr(0, lenght)}...${address.substr(
        address.length - lenght,
        address.length
    )}`;
}